import { Component, ojs, app } from "modular-openscriptjs";
import { either, monetary, formatThousand } from "../../helpers";
import ProfilePic from "../ProfilePic";
import { gc, dc } from "../../ojs.contexts";

const h = app("h");


export default class MinimalProductView extends Component {
	render(productState, ...args) {
		let product = productState.value;

		if (!product?.id) return h.empty();

		let user = product?.owner;

		if (product?.is_copied) {
			user = product?.copier;
		}

		return h.div(
			{
				class: "d-flex p-0 gap-0 position-relative flex-column",
				data_product_id: product?.id,
				$data_product_id: product?.id,
			},

			h.div(
				{ class: "d-flex mb-3 p-0 gap-3 position-relative" },
				h.div(
					{ class: "" },
					h.ProfilePic(
						gc.user,
						h.call(() => {
							let path = gc.user?.value?.profile_photo_path;

							if (user?.id != gc.user?.id) {
								path = user?.profile_photo_path;
							}

							return h.img(
								{
									class: "rounded-circle d-block border",
									style: "max-width: 40px; height: auto",
									id: "user-profile-avatar",
								},

								either(
									path,
									{ src: path },
									{ src: "/assets/images/user-avatar.png" }
								)
							);
						})
					)
				),
				h.div(
					{ class: "col" },
					h.div(
						{ class: "d-flex flex-column gap-3" },
						h.div(
							{ class: "row p-0 justify-content-between" },
							h.div(
								{
									class: "col col-auto",
									role: "button",
									onclick: h.func(
										"route.to",
										"user.view-profile",
										{
											user:
												user?.id == gc.user?.id
													? "current"
													: user?.id,
										}
									),
								},
								h.div(
									{ class: "m-0" },
									h.span(
										{ class: "fw-bold me-2" },
										user?.display_name
									),
									either(
										user?.is_business,
										() =>
											h.span(
												{ class: "text-info" },
												h.i({ class: "fas fa-shop" })
											),
										either(user?.is_verified, () =>
											h.span(
												{ class: "text-info" },
												h.i({
													class: "fas fa-circle-check",
												})
											)
										)
									)
								),

								h.div(
									{
										class: "overflow-ellipsis d-md-none m-0 form-text",
									},
									h.span(
										{ class: "text-secondary d-block" },
										"@",
										user?.username
									)
								)
							),
							h.div(
								{
									class: "col overflow-ellipsis d-none d-md-block p-0",
									role: "button",
									onclick: h.func(
										"route.to",
										"user.view-profile",
										{
											user:
												user?.id == gc.user?.id
													? "current"
													: user?.id,
										}
									),
								},
								h.span(
									{ class: "text-secondary" },
									"@",
									user?.username
								)
							)
						)
					)
				)
			),

			h.div(
				{ class: "d-flex flex-column pe-3 mb-0" },

				h.div(
					{
						class: "fs-5 mb-1",
						onclick: h.func("route.to", "product.view-product", {
							productId: product?.id,
							u: user?.id,
						}),
					},
					product?.name
				),
				h.div(
					{
						class: "text-dark small",
						onclick: h.func("route.to", "product.view-product", {
							productId: product?.id,
							u: user?.id,
						}),
					},
					h.call(() => {
						let div = h.fromString(product?.description, "div", {
							onclick: h.func(
								"route.to",
								"product.view-product",
								{
									productId: product?.id,
									u: user?.id,
								}
							),
						});

						let description = div.textContent;

						return either(
							description && description?.length > 50,
							() => description?.substring(0, 50) + "...",
							description
						);
					})
				),

				h.div(
					{ class: "col-auto overflow-ellipsis mt-2" },
					h.span({ class: "form-text" }, product?.shared_at)
				)
			),
			h.hr(),
			h.div(
				{
					class: "d-flex justify-content-between small",
					onclick: h.func("route.to", "product.view-product", {
						productId: product?.id,
						u: user?.id,
					}),
				},
				h.div(
					{
						class: "d-flex gap-1 mb-2 fs-xsm fst-italic text-secondary",
					},
					h.span(
						either(
							product?.discounted_price &&
								product?.discounted_price < product?.price,
							{
								class: "text-danger text-decoration-line-through",
							},
							{ class: "text-primary" }
						),
						"≈",
						monetary(product?.price, dc.userCurrency)
					),

					either(
						product?.discounted_price &&
							product?.discounted_price < product?.price,
						() =>
							h.span(
								{ class: "text-success" },
								monetary(
									product?.discounted_price,
									dc.userCurrency
								)
							)
					)
				),

				h.div(
					{
						class: "d-flex justify-content-between text-secondary gap-4",
					},
					h.span(
						{
							class: "d-flex gap-1 align-items-center text-danger",
						},
						either(
							product?.current_like &&
								product?.current_like.length,
							() => [
								h.i({
									class: "fas fa-heart animated-icon animated-add",
								}),
							],
							() => [
								h.i({
									class: "far fa-heart animated-icon animated-remove",
								}),
							]
						),
						formatThousand(product?.like_count)
					),
					either(product?.is_saveable == 1, () =>
						h.span(
							{
								class: "d-flex gap-1 align-items-center",
								style: `color: #eea91c;`,
							},
							either(
								!(
									(product.owner_id == gc.user?.id &&
										product.pivot?.user_id ==
											gc.user?.id) ||
									(gc.user?.id == product.pivot?.user_id &&
										gc.user?.id == user?.id &&
										product.parent_product != null) ||
									product?.copied_by_id == gc.user?.id
								),

								() =>
									either(
										product?.current_bookmark,
										() => [
											h.i({
												class: "fas fa-bookmark animated-icon animated-add",
											}),
										],
										() => [
											h.i({
												class: "far fa-bookmark animated-icon animated-remove",
											}),
										]
									),
								() =>
									h.i({
										class: "far fa-bookmark animated-icon animated-remove",
									})
							),

							formatThousand(product?.save_count)
						)
					),
					h.span(
						{
							class: "d-flex gap-1 align-items-center",
						},
						h.i({ class: "far fa-clipboard" }),
						formatThousand(product?.carted_count)
					)
				)
			),
			...args
		);
	}
}

ojs(ProfilePic, MinimalProductView);
